export const ourStaffEditComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        parentSlug: '@'
    },

    template: `
        <our-staff-main
            disable-buttons='$ctrl.disableButtons'
            details='$ctrl.details'
            parent-slug='{{$ctrl.parentSlug}}'
		    on-submit='$ctrl.onSubmit(details)'
            page-title='Edit Staff'
        >
        </our-staff-main>
    `,

    controller: class OurStaffEditComponent {

        constructor($state, toastr, AboutUsService, DynamicMenusService) {
            'ngInject';

            this.$state = $state;
            this.toastr = toastr;
            this.aboutUsService = AboutUsService;
            this.dynamicMenusService = DynamicMenusService;
        }

        $onInit() {
            this.details = this.aboutUsService._getStaffDetailsObject(this.details.data);
            this.disableButtons = false;
        }

        onSubmit(details) {
            this.disableButtons = true;
            details = this.aboutUsService._setStaffDetails(details);

            this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, details)
                .then(_ => {
                    this.toastr.success("Staff details updated successfully.");
                    this._redirectToParentState(this.parentSlug);
                })
                .catch(err => {
                    this.toastr.error(err);
                    this.disableButtons = false;
                })
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/about-us/our-staff/our-staff-edit/our-staff-edit.component.js